import React from 'react';
import { IoCloseCircle } from 'react-icons/io5';
import { FiArrowLeft } from 'react-icons/fi';
import Closecircle from "../../assets/closecircle.png";

const PopupHeader = ({ title, showBackButton, onGoBack, onClose }) => {
    return (
        <div className="order-screen">
            <div className="header-title">
                {showBackButton && (
                    <FiArrowLeft
                        className="order-arw"
                        onClick={onGoBack}
                    />
                )}
                <div className="bottom-bar">
                    <div>{title}</div>
                    <img src={Closecircle}  onClick={onClose} alt="Confetti popper" style={{ width: '23px', cursor:'pointer', }} />
                </div>
            </div>
        </div>
    );
};

export default PopupHeader;